
export const padZero = (num, len) => {
    let str = `${num}`;
    while (str.length < len) {
        str = '0' + str;
    }
    return str;
};

export const formatTimestamp = seconds => {
    let minutes = (seconds / 60.0) | 0;
    seconds %= 60;
    seconds |= 0;
    return `${minutes}:${padZero(seconds, 2)}`
};